import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, IconButton, Typography, useThemeValue } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared';
import { convertSizeToNumber } from '@/_shared/helpers';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { getEmployerNotCompletedSurveysCall } from '@/surveys/state';

export const EmployeeStartSurvey = () => {
  const t = useTranslations('configuration.learning.employeeStartSurvey');
  const { genericResponsiveValue } = useResponsiveStyle();

  const gapXXXL = convertSizeToNumber(`${useThemeValue('sizes', 'xxxl')}`) || 64;

  const { response: responseGetEmployerNotCompletedSurveys } =
    getEmployerNotCompletedSurveysCall.hook();

  const { campaignId } = useParams();

  const handlePrevious = useCallback(() => {
    window.history.back();
  }, []);

  return (
    <Box
      display='flex'
      flexDirection={genericResponsiveValue({
        breakPoints: { desktop: 'row' },
        defaultValue: 'column',
      })}
      alignItems='flex-start'
      justifyContent='center'
      py={genericResponsiveValue({
        breakPoints: { desktop: 'xl' },
        defaultValue: 'm',
      })}
      width='100%'
      style={{ gap: gapXXXL }}
      flex={10}
    >
      <Box
        flex={genericResponsiveValue({
          breakPoints: { desktop: 6 },
          defaultValue: 10,
        })}
      >
        <Box display='flex'>
          <IconButton
            prefixSvg='chevronLeft'
            variant='link/primary'
            onClick={handlePrevious}
            style={{ textDecoration: 'none', cursor: 'pointer' }}
            svgStyle={{ width: 'xs' }}
            textStyle={{ variant: 'p2/light', marginLeft: 'xxxxs' }}
          >
            {t('previousButton')}
          </IconButton>
        </Box>
        <Typography
          variant='h2'
          fontSize={genericResponsiveValue({
            breakPoints: { desktop: 50 as never },
            defaultValue: 'xxxl',
          })}
          lineHeight={genericResponsiveValue({
            breakPoints: { desktop: '60px' as never },
            defaultValue: 'xxxl',
          })}
          fontWeight='bold'
          mb={genericResponsiveValue({
            breakPoints: { desktop: 'm' },
            defaultValue: 'xs',
          })}
        >
          {t('title')}
        </Typography>
        <Typography variant='h4' fontWeight={200} mb='l' color='primary/text'>
          {t('subtitle', {
            templateName:
              responseGetEmployerNotCompletedSurveys?.filter(
                survey => survey.campaignId === campaignId,
              )[0].templateName || '',
          })}
        </Typography>
        <AlertBadge
          label={t(
            `disclaimer.${
              responseGetEmployerNotCompletedSurveys?.filter(
                survey => survey.campaignId === campaignId,
              )[0].templateName
            }` || '',
          )}
          type='transparent'
          iconName='lightBulb'
        />
      </Box>
      <Box
        flex={genericResponsiveValue({
          breakPoints: { desktop: 4 },
          defaultValue: 10,
        })}
      />
    </Box>
  );
};
